import ErrorTemplate from './ErrorTemplate'
import { useDispatch } from 'react-redux'
import React, { useEffect } from 'react'
import { setPageName } from '../../redux'

function Server500() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setPageName('500'))
  }, [])

  return <ErrorTemplate error_code={500} />
}

export default React.memo(Server500)
